import React, { useEffect, useState, useCallback } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { renderToString } from 'react-dom/server'
import moment from 'moment';
import { useSelector } from 'react-redux';
import { eventDetailViewSelector } from '../../../features/events/eventsSlice';


const OsmEventMarker = () => {
    const map = useMap();
    const eventDetailView = useSelector(eventDetailViewSelector);
    const eventData = useSelector(state => state.events.eventContent[`${eventDetailView}`]);
    let icon = `/assets/history/def30/event.png`;
    const [showLabel, setshowLabel] = useState(true);


    const [theIcon, setTheIcon] = useState(null);
    const [theLabel, setTheLabel] = useState(null);

    const createMarker = useCallback(
        () => {
            if (eventDetailView && eventData) {
                //console.log("going for event icon");
                const tic = L.marker(
                    [parseFloat(eventData.lat), parseFloat(eventData.lng)],
                    {
                        icon: L.icon({
                            iconUrl: icon,
                            iconSize: [20, 20]
                        })
                    }
                ).on('click', () => setshowLabel(!showLabel));
                map.addLayer(tic);
                setTheIcon(tic);

                if (showLabel) {
                    const { regn, event_desc, event_time, address, speed } = eventData;
                    const eventLabel = L.divIcon({
                        html: renderToString(
                            <div style={{ width: '250px', backgroundColor: "Ivory" }}>
                                <div style={{ margin: '10px' }}>
                                    <div>
                                        <b>{regn}</b>
                                    </div>
                                    <div>
                                        <b>{event_desc}</b>
                                    </div>
                                    <div>
                                        {address && address.location}
                                    </div>
                                    {
                                        speed && <div>Speed: {speed} Km/h</div>
                                    }
                                    <div>
                                        {moment(event_time).format('Do MMM YY hh:mm:ss A')}
                                    </div>
                                </div>

                            </div>
                        ),
                        iconAnchor: [-10, -10],
                        className: 'dummy'
                    })

                    const tlbl = L.marker(
                        [parseFloat(eventData.lat), parseFloat(eventData.lng)],
                        { icon: eventLabel }
                    );

                    map.addLayer(tlbl);
                    setTheLabel(tlbl);
                }


            }
        },
        [eventDetailView, eventData, showLabel, icon, map],
    )

    useEffect(() => {
        if (!theIcon) {
            //console.log("launching event marker");
            createMarker();
        }
        return () => {
            if (theIcon) {
                map.removeLayer(theIcon);
                setTheIcon(null);
            }
            if (theLabel) {
                map.removeLayer(theLabel);
                setTheLabel(null);
            }
        }
    }, [theIcon, theLabel, map, createMarker])


    return null;
}

export default OsmEventMarker;